import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Contact } from './contact.model';
import { ContactService } from './contact.service';
@Injectable()
export class ContactPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private contactService: ContactService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.contactService.find(id).subscribe((contact) => {
                contact.updated = this.datePipe
                    .transform(contact.updated, 'yyyy-MM-ddThh:mm');
                contact.created = this.datePipe
                    .transform(contact.created, 'yyyy-MM-ddThh:mm');
                this.contactModalRef(component, contact);
            });
        } else {
            return this.contactModalRef(component, new Contact());
        }
    }

    contactModalRef(component: Component, contact: Contact): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.contact = contact;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact-popup.service.ts